import * as commonFuncs from './services/common-functions';
import Theme from './components/theme/theme.jsx';
import Wrapper from './components/wrapper/wrapper.jsx';
import BoxTool from './components/box/box-tool.jsx';
import Box from './components/box/box.jsx';
import BarChart from './components/charts/bar-chart.jsx';
import DoughnutChart from './components/charts/doughnut-chart.jsx';
import LineChart from './components/charts/line-chart.jsx';
import MapChart from './components/charts/map-chart.jsx';
import PieChart from './components/charts/pie-chart.jsx';
import RadarChart from './components/charts/radar-chart.jsx';
import ChatBox from './components/chat-box/chat-box.jsx';
import Contacts from './components/chat-box/contacts.jsx';
import Conversations from './components/chat-box/conversations.jsx';
import Breadcrumbs from './components/content-header/breadcrumbs.jsx';
import ContentHeader from './components/content-header/content-header.jsx';
import ContentWrapper from './components/content-wrapper/content-wrapper.jsx';
import ControlsMenu from './components/controls-menu/controls-menu.jsx';
import ControlsMenuTab from './components/controls-menu/controls-menu-tab.jsx';
import ControlsMenuTabSection from './components/controls-menu/controls-menu-tab-section.jsx';
import SimpleTable from './components/table/simple-table/simple-table.jsx';
import DataTable from './components/table/data-table/data-table.jsx';
import DataTableButton from './components/table/data-table/data-table-button.jsx';
import Footer from './components/footer/footer.jsx';
import Form from './components/form/form.jsx';
import DatePicker from './components/form/pieces/date-picker.jsx';
import Select from './components/form/pieces/select.jsx';
import SearchBar from './components/form/pieces/search-bar.jsx';
import HeaderBar from './components/header-bar/header-bar.jsx';
import HeaderMessages from './components/header-bar/header-messages/header-messages.jsx';
import MessageItem from './components/header-bar/header-messages/message-item.jsx';
import HeaderNotifications from './components/header-bar/header-notifications/header-notifications.jsx';
import NotificationItem from './components/header-bar/header-notifications/notification-item.jsx';
import HeaderTasks from './components/header-bar/header-tasks/header-tasks.jsx';
import TaskItem from './components/header-bar/header-tasks/task-item.jsx';
import HeaderSidebarToggle from './components/header-bar/header-sidebar-toggle/header-sidebar-toggle.jsx';
import HeaderUserMenu from './components/header-bar/header-user-menu/header-user-menu.jsx';
import InfoTile from './components/info-tile/info-tile.jsx';
import Modal from './components/modal/modal.jsx';
import NavSidebar from './components/nav-sidebar/nav-sidebar.jsx';
import NavSidebarUserPanel from './components/nav-sidebar/nav-sidebar-user-panel.jsx';
import NavSidebarSearch from './components/nav-sidebar/nav-sidebar-search.jsx';
import NavSidebarMenu from './components/nav-sidebar/nav-sidebar-menu.jsx';
import NavSidebarMenuItem from './components/nav-sidebar/nav-sidebar-menu-item.jsx';
import Attachment from './components/post/attachment.jsx';
import Comment from './components/post/comment.jsx';
import Post from './components/post/post.jsx';
import SocialButton from './components/post/social-button.jsx';
import SocialInfo from './components/post/social-info.jsx';
import ProfileCard from './components/profile-card/profile-card.jsx';
import ProfileInfoList from './components/profile-card/profile-info-list.jsx';
import ProfileInfoBlocks from './components/profile-card/profile-info-blocks.jsx';
import StatTile from './components/stat-tile/stat-tile.jsx';
import Timeline from './components/timeline/timeline.jsx';
import TimelineLabel from './components/timeline/timeline-label.jsx';
import TimelineItem from './components/timeline/timeline-item/timeline-item.jsx';
import TimelineHeader from './components/timeline/timeline-item/timeline-header.jsx';
import TimelineBody from './components/timeline/timeline-item/timeline-body.jsx';
import TimelineFooter from './components/timeline/timeline-item/timeline-footer.jsx';
import ErrorMessage from './components/utilities/error-message.jsx';
import LoadStatus from './components/utilities/load-status.jsx';
import Label from './components/utilities/label.jsx';
import DropdownList from './components/dropdown-list/dropdown-list.jsx';
import Tabs from './components/tabs/tabs.jsx';
import LoginForm from './components/form/common/login-form.jsx';
import RegisterForm from './components/form/common/register-form.jsx';
import Blockquote from './components/text/blockquote.jsx';
import List from './components/text/list.jsx';
import DList from './components/text/d-list.jsx';
import ErrorPage from './components/utilities/error-page.jsx';
import ImageCarousel from './components/image-carousel/image-carousel.jsx';
import Accordion from './components/accordion/accordion.jsx';
import ProgressBar from './components/utilities/progress-bar.jsx';
import Feature from './components/feature/feature.jsx';
import TodoList from './components/todo-list/todo-list.jsx';

//  Export all the components
export {
  commonFuncs,
  Theme,
  Wrapper,
  HeaderBar,
  NavSidebar,
  NavSidebarMenu,
  NavSidebarMenuItem,
  ContentWrapper,
  Footer,
  Label,
  StatTile,
  InfoTile,
  LineChart,
  BarChart,
  PieChart,
  DoughnutChart,
  RadarChart,
  MapChart,
  Box,
  BoxTool,
  Conversations,
  Contacts,
  ChatBox,
  ProfileInfoList,
  ProfileInfoBlocks,
  ProfileCard,
  SocialButton,
  SocialInfo,
  Post,
  Timeline,
  DataTableButton,
  SimpleTable,
  DataTable,
  DropdownList,
  Tabs,
  Form,
  LoginForm,
  RegisterForm,
  Modal,
  Blockquote,
  List,
  DList,
  ErrorPage,
  ImageCarousel,
  Accordion,
  ProgressBar,
  Breadcrumbs,
  ContentHeader,
  ControlsMenu,
  ControlsMenuTab,
  ControlsMenuTabSection,
  DatePicker,
  Select,
  //  TODO: UPDATE THIS FILE AND THEN UNCOMMENT LATER
  // SearchBar,
  HeaderMessages,
  MessageItem,
  HeaderNotifications,
  NotificationItem,
  HeaderTasks,
  TaskItem,
  HeaderSidebarToggle,
  HeaderUserMenu,
  NavSidebarUserPanel,
  NavSidebarSearch,
  Attachment,
  Comment,
  TimelineLabel,
  TimelineItem,
  TimelineHeader,
  TimelineBody,
  TimelineFooter,
  ErrorMessage,
  LoadStatus,
  Feature,
  TodoList
};
